"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function default_1(object) {
    var position = {
        top: object.top,
        left: object.left,
    };
    var top = object.top, left = object.left, fill = object.fill, path = object.path;
    return __assign(__assign(__assign({}, constants_1.path), position), { stroke: object.stroke, strokeWidth: object.strokeWidth, strokeDashArray: object.strokeDashArray, strokeLineCap: object.strokeLineCap, strokeLineJoin: object.strokeLineJoin, strokeUniform: object.strokeUniform, strokeMiterLimit: object.strokeMiterLimit, strokeDashOffset: object.strokeDashOffset, fill: fill, path: path });
}
exports.default = default_1;
//# sourceMappingURL=shape.js.map